import React, { useState } from "react";
import Handler from "../../../Helpers/Handler";
import "../../../Assets/css/style.css";

const STARS = [1, 2, 3, 4, 5];

const STAR_LABELS = {
  1: "Poor",
  2: "Fair",
  3: "Good",
  4: "Very Good",
  5: "Excellent",
};

const ReviewForm = ({
  vendorId,
  vendorName = "Vendor",
  eventId   = null,
  dealId    = null,
  onClose,
  onSuccess,
}) => {
  const [rating,      setRating]      = useState(0);
  const [hovered,     setHovered]     = useState(0);
  const [review,      setReview]      = useState("");
  const [submitting,  setSubmitting]  = useState(false);
  const [error,       setError]       = useState("");
  const [success,     setSuccess]     = useState("");

  const handleSubmit = async () => {
    setError("");
    if (!rating)         return setError("Please select a rating.");
    if (!vendorId)       return setError("Vendor information missing.");
    if (!eventId && !dealId) return setError("Event or Deal reference missing.");

    setSubmitting(true);
    const payload = {
      vendor_id: vendorId,
      rating,
      review: review.trim(),
    };
    if (eventId) payload.event_id = eventId;
    if (dealId)  payload.deal_id  = dealId;

    const res = await Handler({
      method: "POST",
      url: "/reviews/review.php",
      data: payload,
    });
    setSubmitting(false);

    if (res.success) {
      setSuccess("Review submitted successfully!");
      setTimeout(() => {
        onSuccess && onSuccess();
        onClose && onClose();
      }, 1200);
    } else {
      setError(res.message || "Failed to submit review.");
    }
  };

  const displayRating = hovered || rating;

  return (
    <div className="rv-overlay" onClick={onClose}>
      <div className="rv-modal" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="rv-modal-header">
          <div className="rv-modal-title">
            <div className="rv-modal-icon"><i className="bx bxs-star" /></div>
            <div>
              <h5>Rate & Review</h5>
              <p>{vendorName}</p>
            </div>
          </div>
          <button className="rv-close-btn" onClick={onClose}>
            <i className="bx bx-x" />
          </button>
        </div>

        {/* Alerts */}
        {error   && <div className="rv-alert rv-alert--error"><i className="bx bx-error-circle" />{error}</div>}
        {success && <div className="rv-alert rv-alert--success"><i className="bx bx-check-circle" />{success}</div>}

        {/* Star Rating */}
        <div className="rv-stars-section">
          <div className="rv-stars-label">Your Rating</div>
          <div className="rv-stars-row">
            {STARS.map((s) => (
              <button
                key={s}
                className={`rv-star-btn ${s <= displayRating ? "rv-star-btn--filled" : ""}`}
                onMouseEnter={() => setHovered(s)}
                onMouseLeave={() => setHovered(0)}
                onClick={() => setRating(s)}
                type="button"
              >
                <i className={`bx ${s <= displayRating ? "bxs-star" : "bx-star"}`} />
              </button>
            ))}
          </div>
          {displayRating > 0 && (
            <div className="rv-star-label-text">
              {STAR_LABELS[displayRating]}
            </div>
          )}
        </div>

        {/* Review Text */}
        <div className="rv-field">
          <label>Feedback <span className="rv-optional">(optional)</span></label>
          <textarea
            className="rv-textarea"
            placeholder="Share your experience with this vendor…"
            value={review}
            onChange={(e) => setReview(e.target.value)}
            rows={4}
            maxLength={500}
          />
          <div className="rv-char-count">{review.length}/500</div>
        </div>

        {/* Context Badge */}
        <div className="rv-context-badge">
          <i className={`bx ${eventId ? "bx-calendar-event" : "bx-briefcase"}`} />
          {eventId ? `Event #${eventId}` : `Deal #${dealId}`}
        </div>

        {/* Actions */}
        <div className="rv-modal-actions">
          <button className="rv-btn-cancel" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button
            className="rv-btn-submit"
            onClick={handleSubmit}
            disabled={submitting || !rating}
          >
            {submitting
              ? <><i className="bx bx-loader-alt bx-spin" /> Submitting…</>
              : <><i className="bx bxs-send" /> Submit Review</>
            }
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReviewForm;